import { useDispatch } from "react-redux";
import { setLoader } from "../../../Store/Slice/techsbookSlice";
import showToast from "../../Hooks/toast";
import {useGetExcelMutation, useGetJobFormsMutation} from "../../../Store/Builder/jobs.api";
import { setJobForms } from "../../../Store/Slice/jobsSlice";
import axios from "axios";

const useGetJobFormsApi = () => {
  const dispatch = useDispatch();
  const [getJobForms] = useGetJobFormsMutation();

  const get = (params) => {
    dispatch(setLoader(true));
    getJobForms(params)
      .unwrap()
      .then((res) => {
        dispatch(setLoader(false));
        dispatch(setJobForms(res));
      })
      .catch((err) => {
        dispatch(setLoader(false));
        showToast(err?.data?.message ?? "Error account", "error");
      });
  };

  const downloadExcel = (params, link) => {
    dispatch(setLoader(true))
    const token = localStorage.getItem('techsbook_customer_portal_token')
    axios({
      url: `${process.env.REACT_APP_API_URL_DEVELOP}/jobs/job-forms/export?${params}`,
      method: 'GET',
      responseType: 'blob',
      headers: {
        'Authorization': `Bearer ${token}`
      }
    })
      .then((res) => {
        link.href = window.URL.createObjectURL(new Blob([res.data]))
        link.setAttribute('download', 'Vehicles.xlsx')
        link.click()
        link.removeAttribute('href')
        link.removeAttribute('download')
        dispatch(setLoader(false))
      })
      .catch((err) => {
        console.log(err)
        dispatch(setLoader(false))
      })
  }

  return {
    get,
    downloadExcel
  };
};

export default useGetJobFormsApi;
